import 'css-chunk:src/ImageArea/ImageArea.module.scss';export default {
  "img_area": "img_area__yrgop",
  "logo": "logo__b2BhI",
  "poyoyon": "poyoyon__W2jK6",
  "subtitle": "subtitle__w7aIo"
};